import React, { useEffect } from 'react';

// static assets 
import signPost from './static/images/signpost-red.svg';

// screens
import Tabs from './screens/tabs.js';
import LogIn from './screens/logIn.js'
import NewProjectReceipt from './screens/newProjectReceipt.js';
import SelectProjectReceipt from './screens/selectProjectReceipt.js';
import AdminSection from './screens/admin.js';
import CoverPage from './screens/coverPage.js'
import LaborDetails from './screens/laborDetails.js'
import MaterialsDetails from './screens/materialsDetails.js'
import Footer from './screens/footer.js'

function App() {

  useEffect(() => {
    console.log('useEffect in App.js')
  }, [])

  return (
      <React.Fragment>

        <main className="papertrail-main">

          {/* <!-- title section --> */}
          <div className="papertrail-title">

            {/* <!-- title text --> */}
            <p className="papertrail-title-text">
              Papertrail
            </p>

            {/* <!-- signpost --> */}
            <img 
              // src="./static/images/signpost-red.svg"
              src={signPost}
              alt="red signpost logo"
              className="signpost-red"
            />

          </div>

          <br/><div className="papertrail-description">
            <p className="papertrail-title-text">
              An expenses and reporting tool for the Faculty and Staff of Boston University, College of Arts and Sciences.
            </p>
          </div>

          <br/><div className="bu-redline"></div><br/>

          {/* CONTENT SECTIONS */}

          <Tabs />

          <div
            id="container-log-in"
            className="log-in-block">
            <LogIn/>
          </div>

          <div
            id="container-new-project-receipt"
            className="new-project-receipt-content-block"
            style ={{ width: '80%' }}>
            <NewProjectReceipt />
          </div>

          <div 
            id="container-select-project-receipt" 
            className="container-select-project-receipt">
              <SelectProjectReceipt />
          </div>

          {/* admin */}
          <div 
            id="container-admin" 
            className="container-admin">
                <AdminSection/>
          </div>

          {/* cover page */}
          <div 
            id="container-cover-page" 
            className="container-cover-page">
            <CoverPage/>
          </div>

          {/* labor details */}
          <div 
            id="container-labor-details-page" 
            className="container-labor-details-page">
            <LaborDetails/>
          </div>

          {/* materials details */}
          <div 
            id="container-materials-details-page" 
            className="container-materials-detail-page"
            style={{ display: 'none', visibility: 'hidden' }}>
            <MaterialsDetails/>
          </div>

          <Footer/>

        </main>
        </React.Fragment>
  );
}

export default App;
